import api from '@/services/api';
import Vue from 'vue';
import { make } from 'vuex-pathify';
const state = {
  notes: {},
};
const mutations = {
  ...make.mutations(state),
  SET_NOTES: (state, data) => {
    const { dataSourceName, featureId, notes } = data;
    if (!state.notes.dataSourceName) {
      Vue.set(state.notes, dataSourceName, {});
    }
    Vue.set(state.notes[dataSourceName], featureId, notes);
  },
};
const actions = {
  async getNotes({ commit }, payload) {
    const { data_source_name, feature_id } = payload;
    const r = await api.get(`/dataio/data_sources/${data_source_name}/features/${feature_id}/notes`);
    commit('SET_NOTES', { dataSourceName: data_source_name, featureId: feature_id, notes: r.data.data });
  },
  async addNote({ dispatch }, payload) {
    await api.post(`/notes`, payload);
    const name = payload.target_objects[0].datasource_name;
    const id = payload.target_objects[0].feature_id;
    await dispatch('getNotes', { data_source_name: name, feature_id: id });
  },
  async deleteNote({ dispatch }, payload) {
    const { id, data_source_name, feature_id } = payload;
    await api.delete(`/notes/${id}`);
    await dispatch('getNotes', { data_source_name: data_source_name, feature_id: feature_id });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
